/* eslint-disable check-file/filename-blocklist */
import { COLOR_NAMES, PRIMARY_COLORS } from './colors.ts';

// BE requires the color passed to it in hex but new tokens makes the color as a var(). This function helps translate between
// the color representations.
export const tokenToHex = (
	color: string | null,
): '#2684FF' | '#57D9A3' | '#FFC400' | '#8777D9' | '#FF7452' | '#1d7afc' => {
	switch (color) {
		case PRIMARY_COLORS.BLUE:
			return '#2684FF';
		case PRIMARY_COLORS.GREEN:
			return '#57D9A3';
		case PRIMARY_COLORS.YELLOW:
			return '#FFC400';
		case PRIMARY_COLORS.PURPLE:
			return '#8777D9';
		case PRIMARY_COLORS.RED:
			return '#FF7452';
		case PRIMARY_COLORS.VERIFIED:
			return '#1d7afc';
		default:
			return '#2684FF';
	}
};

export const hexToToken = (color: string): string => {
	const upperCaseColor = color?.toUpperCase(); // need toUpper since color we get from BE is lowercase
	switch (upperCaseColor) {
		case '#2684FF':
			return PRIMARY_COLORS.BLUE;
		case '#57D9A3':
			return PRIMARY_COLORS.GREEN;
		case '#FFC400':
			return PRIMARY_COLORS.YELLOW;
		case '#8777D9':
			return PRIMARY_COLORS.PURPLE;
		case '#FF7452':
			return PRIMARY_COLORS.RED;
		default:
			return color;
	}
};

export function colorCodeToColorName(colorCode: string | null | undefined): string {
	const upperCaseColorCode = colorCode?.toUpperCase();
	switch (upperCaseColorCode) {
		case PRIMARY_COLORS.BLUE.toUpperCase():
			return COLOR_NAMES.BLUE;
		case PRIMARY_COLORS.GREEN.toUpperCase():
			return COLOR_NAMES.GREEN;
		case PRIMARY_COLORS.YELLOW.toUpperCase():
			return COLOR_NAMES.YELLOW;
		case PRIMARY_COLORS.RED.toUpperCase():
			return COLOR_NAMES.RED;
		case PRIMARY_COLORS.PURPLE.toUpperCase():
			return COLOR_NAMES.PURPLE;
		default:
			return COLOR_NAMES.BLUE;
	}
}
